export default {
  authType: {
    'kin': 0,
    'mfg': 1
  },
  permissionType: {
    1: "routePermissions",
    2: "actionPermissions",
  },
  permissionTypeSlug: {
    route: 1,
    action: 2,
  },
  skipPermissions: [
    "dashboard",
    "login",
    "logout",
    "not_found",
    "settings"
  ],
  activityActions: {
    comment: 1,
    edit: 2,
    approved: 33,
    request_changes: 32,
    submitted: 31,
    rejected: 38,
    status_updated: 39,
  },
  timelineFilter: {
    all_activities: 0,
    only_comments: 1,
  },
  activityIcons: {
    2: `<svg viewBox="0 0 20 20" class="h-5 w-5 text-neutral-800" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.8898 3.11019L17.4201 2.57986V2.57986L16.8898 3.11019ZM5.41667 17.5296V18.2796C5.61558 18.2796 5.80634 18.2005 5.947 18.0599L5.41667 17.5296ZM2.5 17.5296H1.75C1.75 17.9438 2.08579 18.2796 2.5 18.2796V17.5296ZM2.5 14.5537L1.96967 14.0233C1.82902 14.164 1.75 14.3548 1.75 14.5537H2.5ZM14.4738 3.64052C14.9945 3.11983 15.8387 3.11983 16.3594 3.64052L17.4201 2.57986C16.3136 1.47338 14.5196 1.47338 13.4131 2.57986L14.4738 3.64052ZM16.3594 3.64052C16.8801 4.16122 16.8801 5.00544 16.3594 5.52614L17.4201 6.5868C18.5266 5.48032 18.5266 3.68635 17.4201 2.57986L16.3594 3.64052ZM16.3594 5.52614L4.88634 16.9992L5.947 18.0599L17.4201 6.5868L16.3594 5.52614ZM5.41667 16.7796H2.5V18.2796H5.41667V16.7796ZM13.4131 2.57986L1.96967 14.0233L3.03033 15.084L14.4738 3.64052L13.4131 2.57986ZM1.75 14.5537V17.5296H3.25V14.5537H1.75ZM12.1632 4.89052L15.1094 7.8368L16.1701 6.77614L13.2238 3.82986L12.1632 4.89052Z" fill="#444451"></path>
        </svg>`,
    12: `<svg viewBox="0 0 20 20" class="h-5 w-5 text-neutral-800"  viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <path d="M10.0002 3.33203V16.6654M16.6668 9.9987L3.3335 9.9987" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>`,
    39: `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.16683 3.16667H3.00016C2.07969 3.16667 1.3335 3.91286 1.3335 4.83334V14C1.3335 14.9205 2.07969 15.6667 3.00016 15.6667H12.1668C13.0873 15.6667 13.8335 14.9205 13.8335 14V9.83333M12.655 1.98816C13.3059 1.33728 14.3611 1.33728 15.012 1.98816C15.6629 2.63903 15.6629 3.6943 15.012 4.34518L7.85718 11.5H5.50016L5.50016 9.14298L12.655 1.98816Z" stroke="#444451" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
    37: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="#6B7280"></circle><path d="M5 15L15 5M5 5L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
    36: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.5 6.66602L9.0755 11.0497C9.63533 11.4229 10.3647 11.4229 10.9245 11.0497L17.5 6.66602M4.16667 15.8327H15.8333C16.7538 15.8327 17.5 15.0865 17.5 14.166V5.83268C17.5 4.91221 16.7538 4.16602 15.8333 4.16602H4.16667C3.24619 4.16602 2.5 4.91221 2.5 5.83268V14.166C2.5 15.0865 3.24619 15.8327 4.16667 15.8327Z" stroke="#444451" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
  },
  flagIcons: {
    'USD': `<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_270_55071)">
                <rect width="16" height="12" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H16V12H0V0Z" fill="#E31D1C" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1V2H16V1H0ZM0 3V4H16V3H0ZM0 6V5H16V6H0ZM0 7V8H16V7H0ZM0 10V9H16V10H0ZM0 12V11H16V12H0Z" fill="#F7FCFF" />
                <rect width="9" height="7" fill="#2E42A5" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.04005 2.17381L1.56997 1.80468L1.98103 2.10061H1.74829L2.21896 2.51691L2.05999 3.10061H1.811L1.56923 2.56451L1.36305 3.10061H0.748291L1.21896 3.51691L1.04005 4.17381L1.56997 3.80468L1.98103 4.10061H1.74829L2.21896 4.51691L2.05999 5.10061H1.811L1.56923 4.56451L1.36305 5.10061H0.748291L1.21896 5.51691L1.04005 6.17381L1.56997 5.80468L2.08271 6.17381L1.92329 5.51691L2.33506 5.10061H2.14514L2.56997 4.80468L2.98103 5.10061H2.74829L3.21896 5.51691L3.04005 6.17381L3.56997 5.80468L4.08271 6.17381L3.92329 5.51691L4.33506 5.10061H4.14514L4.56997 4.80468L4.98103 5.10061H4.74829L5.21896 5.51691L5.04005 6.17381L5.56997 5.80468L6.08271 6.17381L5.92329 5.51691L6.33506 5.10061H6.14514L6.56997 4.80468L6.98103 5.10061H6.74829L7.21896 5.51691L7.04005 6.17381L7.56997 5.80468L8.08271 6.17381L7.92329 5.51691L8.33506 5.10061H7.811L7.56923 4.56451L7.36305 5.10061H7.06494L6.92329 4.51691L7.33506 4.10061H7.14514L7.56997 3.80468L8.08271 4.17381L7.92329 3.51691L8.33506 3.10061H7.811L7.56923 2.56451L7.36305 3.10061H7.06494L6.92329 2.51691L7.33506 2.10061H7.14514L7.56997 1.80468L8.08271 2.17381L7.92329 1.51691L8.33506 1.10061H7.811L7.56923 0.564514L7.36305 1.10061H6.74829L7.21896 1.51691L7.05999 2.10061H6.811L6.56923 1.56451L6.36305 2.10061H6.06494L5.92329 1.51691L6.33506 1.10061H5.811L5.56923 0.564514L5.36305 1.10061H4.74829L5.21896 1.51691L5.05999 2.10061H4.811L4.56923 1.56451L4.36305 2.10061H4.06494L3.92329 1.51691L4.33506 1.10061H3.811L3.56923 0.564514L3.36305 1.10061H2.74829L3.21896 1.51691L3.05999 2.10061H2.811L2.56923 1.56451L2.36305 2.10061H2.06494L1.92329 1.51691L2.33506 1.10061H1.811L1.56923 0.564514L1.36305 1.10061H0.748291L1.21896 1.51691L1.04005 2.17381ZM7.05999 4.10061L7.21896 3.51691L6.74829 3.10061H6.98103L6.56997 2.80468L6.14514 3.10061H6.33506L5.92329 3.51691L6.06494 4.10061H6.36305L6.56923 3.56451L6.811 4.10061H7.05999ZM5.98103 4.10061L5.56997 3.80468L5.14514 4.10061H5.33506L4.92329 4.51691L5.06494 5.10061H5.36305L5.56923 4.56451L5.811 5.10061H6.05999L6.21896 4.51691L5.74829 4.10061H5.98103ZM4.21896 4.51691L4.05999 5.10061H3.811L3.56923 4.56451L3.36305 5.10061H3.06494L2.92329 4.51691L3.33506 4.10061H3.14514L3.56997 3.80468L3.98103 4.10061H3.74829L4.21896 4.51691ZM4.36305 4.10061H4.06494L3.92329 3.51691L4.33506 3.10061H4.14514L4.56997 2.80468L4.98103 3.10061H4.74829L5.21896 3.51691L5.05999 4.10061H4.811L4.56923 3.56451L4.36305 4.10061ZM3.05999 4.10061L3.21896 3.51691L2.74829 3.10061H2.98103L2.56997 2.80468L2.14514 3.10061H2.33506L1.92329 3.51691L2.06494 4.10061H2.36305L2.56923 3.56451L2.811 4.10061H3.05999ZM6.21896 2.51691L6.05999 3.10061H5.811L5.56923 2.56451L5.36305 3.10061H5.06494L4.92329 2.51691L5.33506 2.10061H5.14514L5.56997 1.80468L5.98103 2.10061H5.74829L6.21896 2.51691ZM3.98103 2.10061L3.56997 1.80468L3.14514 2.10061H3.33506L2.92329 2.51691L3.06494 3.10061H3.36305L3.56923 2.56451L3.811 3.10061H4.05999L4.21896 2.51691L3.74829 2.10061H3.98103Z" fill="#F7FCFF" />
              </g>
              <defs>
                <clipPath id="clip0_270_55071">
                  <rect width="16" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>`,
    'CAD': `<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_270_55097)">
                      <rect width="16" height="12" fill="white"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0H12.5V12H4V0Z" fill="#F7FCFF"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.16447 4.20127L7.98652 3L8 10H7.65742L7.86761 8.2677C7.86761 8.2677 5.56179 8.69124 5.75241 8.4776C5.94304 8.26397 6.05283 7.87204 6.05283 7.87204L4 6.47393C4 6.47393 4.32382 6.46978 4.58726 6.30984C4.8507 6.1499 4.32382 5.20134 4.32382 5.20134L5.36027 5.35527L5.75241 4.92023L6.53439 5.7557H6.8859L6.53439 3.842L7.16447 4.20127ZM8 10V3L8.83553 4.20127L9.46561 3.842L9.1141 5.7557H9.46561L10.2476 4.92023L10.6397 5.35527L11.6762 5.20134C11.6762 5.20134 11.1493 6.1499 11.4127 6.30984C11.6762 6.46978 12 6.47393 12 6.47393L9.94717 7.87204C9.94717 7.87204 10.057 8.26397 10.2476 8.4776C10.4382 8.69124 8.13239 8.2677 8.13239 8.2677L8.34258 10H8Z" fill="#E31D1C"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0H16V12H12V0Z" fill="#E31D1C"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H4V12H0V0Z" fill="#E31D1C"/>
                  </g>
                  <defs>
                      <clipPath id="clip0_270_55097">
                          <rect width="16" height="12" fill="white"/>
                      </clipPath>
                  </defs>
              </svg>`
  },
  attachmentMaxSize: 10485760,
  departmentInitials: {
      1: "S",
      2: "M",
      3: "O",
      4: "R",
      5: "W",
      6: "QA",
      7: "CX",
      8: "A"
  },
  departments: {
    systems: 1,	 
    marketing: 2,	 
    operations: 3,
    regulatory: 4,
    warehouse: 5,
    quality: 6,
    customer_service: 7,
    accounting: 8
  },
  roles: {
    super_admin: 1,	 
    viewer: 2,	 
    editor: 3,
    approver: 4,
    admin: 5
  },
  departmentSystem: "Systems",
  roleSuperAdmin: "Super Admin",
  userDefaultColor: "#57bce4",
  codex_part_detail_url: {
        1: "products/detail/",
        2: "kit/detail/",
        3: "raw-material/detail/",
        4: "marketing-material/detail/",
        5: "test-token/detail/",
  },
};